import TemplateNames from '../email-messages/TemplateNames';
import MarketingSubscriptionSources from '../followers/MarketingSubscriptionSources';

export default {
  title: 'Przegląd marketingu',
  tiles: {
    followers: 'Obserwatorzy',
    delivered_messages: 'Dostarczone wiadomości',
    open_rate: 'Wskaźnik otwarć',
    click_rate: 'Wskaźnik kliknięć',
    spam_report_rate: 'Wskaźnik zgłoszeń spamu',
    unsubscribe_rate: 'Wskaźnik wypisów',
  },
  subscriprion_sources_table: {
    source_names: MarketingSubscriptionSources,
    columns: {
      subscription_source: 'Źródło subskrypcji',
      count: 'Liczba',
      percentage: 'Procent',
    },
  },
  templates_table: {
    template_names: TemplateNames,
    columns: {
      template: 'Szablon',
      delivered: 'Dostarczone',
      open_rate: 'Wskaźnik otwarć',
      click_rate: 'Wskaźnik kliknięć',
      spam_report_rate: 'Wskaźnik zgłoszeń spamu',
      unsubscribe_rate: 'Wskaźnik wypisów',
    },
  },
  labels: {
    no_data: 'Brak danych',
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować danych',
  },
};
